/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Image } from './Image';
import {
    ImageFromJSON,
    ImageFromJSONTyped,
    ImageToJSON,
} from './Image';

/**
 * 
 * @export
 * @interface MediqPaymentMethod
 */
export interface MediqPaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof MediqPaymentMethod
     */
    paymentMethod?: string;
    /**
     * 
     * @type {Image}
     * @memberof MediqPaymentMethod
     */
    icon?: Image;
}

/**
 * Check if a given object implements the MediqPaymentMethod interface.
 */
export function instanceOfMediqPaymentMethod(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MediqPaymentMethodFromJSON(json: any): MediqPaymentMethod {
    return MediqPaymentMethodFromJSONTyped(json, false);
}

export function MediqPaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediqPaymentMethod {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethod': !exists(json, 'paymentMethod') ? undefined : json['paymentMethod'],
        'icon': !exists(json, 'icon') ? undefined : ImageFromJSON(json['icon']),
    };
}

export function MediqPaymentMethodToJSON(value?: MediqPaymentMethod | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentMethod': value.paymentMethod,
        'icon': ImageToJSON(value.icon),
    };
}

